import { render, staticRenderFns } from "./CanteenInventory.vue?vue&type=template&id=1489299a&scoped=true&"
import script from "./CanteenInventory.vue?vue&type=script&lang=ts&"
export * from "./CanteenInventory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1489299a",
  null
  
)

export default component.exports